const PERMISSION_KEY= "crm:user_feedback";
const PAGE_URL = {
    USER_FEEDBACK_PAGE: "/admin/crm/user-feedback"
}

export {PERMISSION_KEY, PAGE_URL}

